import React from 'react';

const CBPagination = ({
  current = 1,
  total = 0,
  pageSize = 10,
  onChange, // (page, pageSize) => void
  className = '',
}) => {
  const totalPages = Math.ceil(total / pageSize);

  const handlePrev = () => {
    if (current > 1 && onChange) {
      onChange(current - 1, pageSize);
    }
  };

  const handleNext = () => {
    if (current < totalPages && onChange) {
      onChange(current + 1, pageSize);
    }
  };

  if (total === 0 || totalPages <= 1) return null; // Don't render if only one page or no items

  return (
    <div className={`flex items-center justify-center space-x-2 text-sm ${className}`}>
      <button
        onClick={handlePrev}
        disabled={current <= 1}
        className="px-3 py-1 border rounded text-gray-600 bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        {'< Prev'} {/* Escaped character */}
      </button>
      <span className="text-gray-700">
        Page {current} of {totalPages}
      </span>
      <button
        onClick={handleNext}
        disabled={current >= totalPages}
        className="px-3 py-1 border rounded text-gray-600 bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        {'Next >'} {/* Escaped character */}
      </button>
    </div>
  );
};

export { CBPagination };